import { twMerge } from 'tailwind-merge';
import { cn } from '@/utils';

interface FilterHeaderProps {
  totalFilters: number;
  clearFilters: () => void;
  mobile?: boolean;
}

export const FilterHeader = ({ totalFilters, clearFilters, mobile }: FilterHeaderProps) => {
  return (
    <div className={cn('flex grow items-baseline justify-center px-[3px] md:justify-between', !mobile && 'mt-3')}>
      <h2 className="flex items-center gap-2 text-lg font-semibold">
        <div
          className={twMerge(
            'flex h-5 w-5 items-center justify-center rounded-full bg-ring text-sm font-medium text-white transition-all',
            totalFilters > 0 ? 'opacity-100' : 'hidden',
          )}
        >
          {totalFilters}
        </div>
        <div
          className={twMerge(
            'font-effra text-[22px] font-bold transition-all'
          )}
        >
          Filters
        </div>
      </h2>
      {!mobile && (
        <button
          onClick={clearFilters}
          className="cursor-pointer text-lg font-semibold leading-7 text-ring underline focus:outline-focus-ring"
        >
          Clear all
        </button>
      )}
    </div>
  );
};
